import {
  ThumbsUp, CheckCircle2, Hammer, AlertOctagon, Ban, type LucideIcon,
} from 'lucide-react';
import type { CondicionElemento } from '@/services/api/inventario.api';

/**
 * Metadata visual de la condición física del elemento.
 * Fuente única de verdad para label, icono y colores — reutilizada por el
 * formulario de alta y la lista de inventario.
 */
export const CONDICION_META: Record<
  CondicionElemento,
  { label: string; icon: LucideIcon; text: string; badge: string }
> = {
  EXCELENTE:     { label: 'Excelente',     icon: ThumbsUp,     text: 'text-emerald-600', badge: 'bg-emerald-50 text-emerald-700 ring-emerald-200' },
  BUENO:         { label: 'Bueno',         icon: CheckCircle2, text: 'text-cyan-600',    badge: 'bg-cyan-50 text-cyan-700 ring-cyan-200' },
  EN_REPARACION: { label: 'En Reparación', icon: Hammer,       text: 'text-amber-600',   badge: 'bg-amber-50 text-amber-800 ring-amber-200' },
  DANADO:        { label: 'Dañado',        icon: AlertOctagon, text: 'text-red-600',     badge: 'bg-red-50 text-red-700 ring-red-200' },
  BAJA:          { label: 'Baja',          icon: Ban,          text: 'text-slate-500',   badge: 'bg-slate-100 text-slate-600 ring-slate-200' },
};

/** Orden de presentación de las condiciones (igual que en el mockup). */
export const CONDICIONES: CondicionElemento[] = [
  'EXCELENTE',
  'BUENO',
  'EN_REPARACION',
  'DANADO',
  'BAJA',
];
